import Tippy from '@tippy.js/react';

import { Icon } from '../UI';

export const Legend = ({
  className = '',
  collapsed = false,
  CustomLegend,
}: {
  className?: string;
  collapsed?: boolean;
  CustomLegend: ({ collapsed }: { collapsed?: boolean }) => JSX.Element;
}) => (
  <div className={`${className} flex items-center justify-center mr-2`}>
    {collapsed ? (
      <Tippy content={<CustomLegend collapsed />}>
        <div className={'mr-4'}>
          <Icon svgName="bulletList" />
        </div>
      </Tippy>
    ) : (
      <CustomLegend />
    )}
  </div>
);
